


import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { AppLoadingService } from './apploading.service';
import { API } from 'src/app/configs';
import { MatDialog } from '@angular/material/dialog';
import { DialogActionComponent } from '../components/dialog-action/dialog-action.component';
import { DialogAuthorizationComponent } from '../components/dialog-authorization/dialog-authorization.component';
import { Subscription } from 'rxjs';
import { DialogRestrictedAccessComponent } from '../components/dialog-restricted-access/dialog-restricted-access.component';
import { DialogMaterialComponent } from '../components/dialog-material/dialog-material.component';
import { ReasonComponent } from '../components/reason/reason.component';

@Injectable({
    providedIn: 'root'
})
export class RequestService {

    authorizationContinue:any = null;
    pathS3:any = null;

    pdfSubscription: Subscription;

    constructor(
        
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected als: AppLoadingService,
        public dialog: MatDialog
    ) {

    }


    async setRequestAction(event, data, options:any = {}) {
        
        if (event instanceof MouseEvent)
            event.stopPropagation();
     
        let setAllowedRestrictedAccess = data.type_id == "restricted_access";
        let setAllowRestrictedAccess = data.type_id == "1";
        let setAllowMaterial = data.type_id == "2";
        let setAllowAuthorization = data.type_id == "3";

        let buttons = options?.buttons || [];

        let headerTitle = '';

        if(data.status == '1' && !options?.admin){
            const dialogRef2 = this.dialog.open(DialogActionComponent, 
                {
                 data: {
                    title: 'Sua solicitação está aguardando uma resposta, você receberá uma notificação.',
                    okTitle: 'Ok',
                    cancelNotShow: true
                }});
    
            return;
        }

        if (setAllowedRestrictedAccess) {

            const dialogRef2 = this.dialog.open(DialogActionComponent, 
                {disableClose : true,
                 data: {
                    title:'Deseja cancelar o acesso do usuário ('+data?.name+') ao anúncio '+data.title+'?',
                    cancelTitle:'Não',
                    okTitle:'Sim'
                }});
    
            dialogRef2.afterClosed().subscribe(result => {
                if(result)
                    this.restrictedDisallow(data);
            });
            return;

        }

        if (setAllowRestrictedAccess) {
            if(!options?.admin && data.status == '2'){

                buttons.push({
                    text: 'Perfil da empresa',
                    icon: 'briefcase',
                    handler: () => {
                        this.gs.navigate(['openModal', 'ViewComponentPerson', data?.ad_owner_friendly_name || data?.ad_owner_public_idtext]);
                    }
                });
    
                buttons.push(
                    {
                        text: 'Visualizar anúncio',
                        icon: 'external-link',
                        handler: () => {
                            this.gs.navigate(['openModal', 'ViewComponentAd', data?.friendlyTitle || data?.ad_friendlyTitle]);
                        }
                });

                let modalId = 'DialogActionComponent_'+Math.random();
                const dialogRef2 = this.dialog.open(DialogActionComponent, 
                    {
                    id:modalId,
                    data: {
                        modalId:modalId,
                        title:'Acesso restrito',
                        cancelTitle:'Fechar',
                        okTitle:false,
                        okNotShow: true,
                        buttons : buttons
                    }});


            } else if(options?.admin && data.status == '2' && data.adRestrictedAllowed !== null){

                buttons.push(
                    {
                        text: 'Visualizar anúncio',
                        icon: 'external-link',
                        handler: () => {
                            this.gs.navigate(['openModal', 'ViewComponentAd', data?.friendlyTitle || data?.ad_friendlyTitle]);
                        }
                });

                if(data.adRestrictedAllowed !== null)
                    buttons.push(
                        {
                            text: 'Cancelar acesso',
                            icon: 'trash',
                            handler: () => {

                                const dialogRef = this.dialog.open(DialogActionComponent, 
                                    {disableClose : true,
                                    data: {
                                        title:'Deseja cancelar o acesso do usuário ('+(data?.name || data?.creator_name)+') ao anúncio '+data?.ad_title+'?',
                                        cancelTitle:'Não',
                                        okTitle:'Sim'
                                    }});
                            
                                dialogRef.afterClosed().subscribe(async result => {
                                    console.log(result);
                                    if(result)
                                        await this.requestRestrictedDisallow(data)
                                        .then(result => {
                                            this.gs.transactionData.next({method:'restricted',action:'reload'});
                                        });
                                });
                            }
                    });
                
                let modalId = 'DialogActionComponent_'+Math.random();
                const dialogRef2 = this.dialog.open(DialogActionComponent, 
                    {
                    id:modalId,
                    data: {
                        modalId:modalId,
                        title:'Acesso restrito',
                        cancelTitle:'Fechar',
                        okTitle:false,
                        okNotShow: true,
                        buttons : buttons
                    }});

            } else if(options?.admin && (data.status == '1' || data.adRestrictedAllowed === null)){
            
                let modalId = 'DialogRestrictedAcessComponent_'+Math.random();
                const dialogRef2 = this.dialog.open(DialogRestrictedAccessComponent, 
                {
                    disableClose : true,
                    id:modalId,
                    data: {
                        modalId:modalId,
                        data : data
                    }
                });
                
            } else if(data.status == '-1'){
                
                
                
                let modalId = 'ReasonComponent'+Math.random();
                const dialogRef2 = this.dialog.open(ReasonComponent, 
                    {
                        //disableClose : true,
                    id:modalId,
                    data: {
                        modalId:modalId,
                        title:'Acesso restrito',
                        subtitle : 'Rejeitado',
                        cancelTitle:'Fechar',                       
                        type:'textarea',
                        sendButton: false,
                        readonly: true,
                        reason : data?.decided_message || '(Motivo não preenchido)'
                    }});

              

                return;
            }
            return;

        }

        if (setAllowMaterial) {


            let modalId = 'DialogMaterialComponent_'+Math.random();

            const dialogRef2 = this.dialog.open(DialogMaterialComponent, 
            {   //disableClose : true,
                id:modalId,
                data: {
                    modalId : modalId,
                    ...data
                }
            });
            
    
            return;
        }

        if (setAllowAuthorization) {
            this.authorization(data?.payload? {authorization: data} : data, data?.admin);
            return;
        }

        let modalId = 'DialogActionComponent_'+Math.random();
        const dialogRef2 = this.dialog.open(DialogActionComponent, 
            {disableClose : true,
            id:modalId,
            data: {
                modalId:modalId,
                title:headerTitle,
                cancelTitle:'Fechar',
                okTitle:false,
                okNotShow: true,
                buttons : buttons
            }});

    }

    /* Request */

    async requestReject(data, endpoint){

/*
        const modal = await this.modalController.create({
            component: ReasonComponent,
            cssClass: 'autoHeight bottom transparent',
            //event: ev,
            componentProps : {subtitle : 'Caso não queira justificar a rejeição, deixe o campo vazio'}
          });
      
        modal.onDidDismiss().then( async (r:any) => {
            if(typeof r?.data?.reason !== 'undefined'){
                await this.als.setLoaded(false,'requestReject');

                this.httpService.post<any>(endpoint, {
                    "owner_person_id": data.owner_person_id,
                    "person_request_id": data.person_request_id,
                    "update": data.update,
                    "message" : r.data.reason
                })
                .then(result => {
                    this.gs.transactionData.next({method:'request',action:'reload'});
                })
                .catch((err) => {  
                    this.gs.error(err); 
                })
                .finally(() => {
                    this.als.setLoaded(true,'requestReject');
                });
            }
        });
      
        return await modal.present();
        */
    }


    /* Request Access Restricted*/

    async restrictedAllow(data){
        await this.als.setLoaded(false,'restrictedAllow');
        
        this.httpService.post<any>(API.ad.general.restricted.allow, {
            "owner_person_id": data.owner_person_id,
            "person_request_id": data.person_request_id,
            "update": data.update
        })
        .then(result => {
            this.gs.transactionData.next({method:'request',action:'reload'});
        })
        .catch((err) => {  
            this.gs.error(err); 
        })
        .finally(() => {
            this.als.setLoaded(true,'restrictedAllow');
        });
    }

    async requestRestrictedDisallow(data):Promise<any>{
        await this.als.setLoaded(false,'requestRestrictedDisallow');
        console.log(data);

        return this.httpService.post<any>(API.ad.general.restricted.reject, {
            owner_person_id : data.owner_person_id,
            person_request_id : data.person_request_id,
            update : data.update
        })
        .then(result => {
            this.gs.transactionData.next({method:'request',action:'reload'});
        })
        .catch((err) => {  
            this.gs.error(err); 
        })
        .finally(() => {
            this.als.setLoaded(true,'requestRestrictedDisallow');
        });
    }

    async restrictedDisallow(data):Promise<any>{
        await this.als.setLoaded(false,'restrictedDisallow');
        
        return this.httpService.post<any>(API.ad.general.restricted.disallow, {
            owner_person_id : data.owner_person_id,
            allowed_public_idtext: data?.public_idtext,
            ad_id: data.ad_id
        })
        .then(result => {
            this.gs.transactionData.next({method:'request',action:'reload'});
        })
        .catch((err) => {  
            this.gs.error(err); 
        })
        .finally(() => {
            this.als.setLoaded(true,'restrictedDisallow');
        });
    }


    /** Material */

    async materialRequest(data, reason = ''){
        if((data?.adId && data?.owner?.personId) || data?.personId){

            let modalId = 'ReasonComponent'+Math.random();
            const dialogRef2 = this.dialog.open(ReasonComponent, 
                {
                    //disableClose : true,
                id:modalId,
                data: {
                    modalId:modalId,
                    title:'Material físico',
                    subtitle : 'Informe os materiais desejados e como serão utilizados (Imobiliária, evento, estande, etc..)',
                    cancelTitle:'Fechar',
                    okTitle:'Solicitar',
                    placeholder : 'Digite aqui', 
                    min:5, 
                    max : 250,
                    type:'textarea',
                    reason : reason
                }});
  
            dialogRef2.afterClosed().subscribe(async r => {

                if(typeof r?.reason != 'undefined'){
                    await this.als.setLoaded(false,'materialRequest');

                    this.httpService.post<any>(API.person.general.material.request, {
                        "ad_owner_public_idtext":data?.owner?.publicIdText || data?.public_idtext,
                        "ad_id":data?.adId,
                        "payload": { 
                            "reason": r.reason
                        }
                    })
                    .then(result => {
                        this.gs.error(false,'Solicitação enviada'); 
                        this.gs.transactionData.next({method:'request',action:'reload'});
                    })
                    .catch((err) => {  
                        this.gs.error(err);
                        this.materialRequest(data,r.reason); 
                    })
                    .finally(() => {
                        this.als.setLoaded(true,'materialRequest');
                    });
                }
            });
        }
    }

    async materialAllow(data){

/*
        const modal = await this.modalController.create({
            component: ReasonComponent,
            cssClass: 'autoHeight bottom transparent',
            //event: ev,
            componentProps : {title : 'Material impresso', subtitle : 'Envie uma mensagem ao solicitante', placeholder : 'Digite uma mensagem', max : 150}
          });
      
        modal.onDidDismiss().then( async (r:any) => {

            if(r?.data?.reason){
                await this.als.setLoaded(false,'materialAllow');

                this.httpService.post<any>(API.ad.general.material.allow, {
                    "owner_person_id": data.owner_person_id,
                    "person_request_id": data.person_request_id,
                    "update": data.update,
                    "message" : r.data.reason
                })
                .then(result => {
                    this.gs.transactionData.next({method:'request',action:'reload'});
                })
                .catch((err) => {  
                    this.gs.error(err); 
                })
                .finally(() => {
                    this.als.setLoaded(true,'materialAllow');
                });
            }
        });
      
        return await modal.present();
        */
    }



    /** Authorization REQUEST | ALLOW */


    async authorization(data, admin = false){
        data.admin = admin;
        
        if(data?.authorization?.payload)
            data.authorization.payload = typeof data.authorization.payload === 'string'? JSON.parse(data.authorization.payload) : data.authorization.payload;

        if((parseInt(data?.authorization?.status || '0') == 2 && admin) || (typeof data?.authorization?.status !=='undefined' && !admin)){
            this.setAuthorizationAction(null, data, admin);            

        } else if(((data?.ad_id || data?.adId) && (data?.owner_person_id || data?.owner?.personId)) || (data?.authorization?.payload && ['-1','1'].indexOf(data?.authorization?.status) > -1)){
            this.openAuthorizationRequest(data, admin);
        }
    } 

    async openAuthorizationRequest(data, admin = false){

        let modalId = 'DialogAuthorizationComponent_'+Math.random();
            
        const dialogRef2 = this.dialog.open(DialogAuthorizationComponent, 
        {   //disableClose : true,
            id:modalId,
            data: {
                modalId : modalId,
                admin: admin,
                ...(data?.payload? {authorization : data} : {data:data})
            }
        });
        dialogRef2.afterClosed().subscribe(result => {
            ///console.log(result);
        });
/*
        return;

        const modal = await this.modalController.create({
            component: AuthorizationComponent,
            cssClass: !admin && !data?.authorization? '' : 'autoHeight bottom transparent',
            componentProps : data
        });
    
        modal.onDidDismiss().then( async (r:any) => {
            if(r?.data?.auth){
                this.gs.transactionData.next({method:'request',action:'reload'});
            }
        });
    
        return await modal.present();
        */
    }

   


    async setAuthorizationAction(event, item, admin = false){

        let buttons = [];

        let data = item;

        item = data.authorization;
    
        if(item?.status != '2')
            buttons.push(
            {
                text: 'Visualizar solicitação',
                icon: 'file-signature',
                handler: () => {
                    this.openAuthorizationRequest(data, admin);
                }
            });
        else {
            buttons.push(
            {
                text: 'Visualizar autorização',
                icon: 'external-link',
                handler: () => {
                    window.open(item?.file_url || item?.authorization_file_url,'_system', 'location=yes');
                }
            });
    
            buttons.push(
            {
                text: 'Copiar link do PDF',
                icon: 'copy',
                handler: () => {
                    const el = document.createElement('textarea');
                    el.value = item?.file_url || item?.authorization_file_url;
                    el.setAttribute('readonly', '');
                    el.style.position = 'absolute';
                    el.style.left = '-9999px';
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    this.gs.message('Link copiado');
                }
            });
        }

        if(admin && item?.owner_public_idtext)
            buttons.push({
                text: 'Perfil do autorizado',
                icon: 'user',
                handler: () => {
                    this.gs.openProfile(event, item?.owner_public_idtext, {owner_person_id : item?.owner_person_id, admin:true});
                }
            });
        else if (item?.ad_owner_friendly_name || item?.ad_owner_public_idtext)
            buttons.push({  
                text: 'Perfil da empresa',
                icon: 'briefcase',
                handler: () => {
                    this.gs.openProfile(event, item?.ad_owner_friendly_name || item?.ad_owner_public_idtext, {admin:true});
                }
            });

        if(item?.ad_id)
          buttons.push(
            {
                text: 'Visualizar anúncio',
                icon: 'external-link',
                handler: () => {
                    this.gs.navigate(['openModal', 'ViewComponentAd', item?.friendlyTitle || item?.ad_friendlyTitle]);
                }
          });
          
        buttons.push({
            text: 'Fechar',
            icon: 'times',
            role: 'cancel',
            handler: () => {
            }
          }
        );

        let modalId = 'DialogActionComponent_'+Math.random();

        const dialogRef = this.dialog.open(DialogActionComponent, 
            {
                id:modalId,
                data: {
                    modalId: modalId,
                    title:'Clique na ação desejada',
                    cancelNotShow:true,
                    okNotShow:true,
                    buttons : buttons
                }
            });

          dialogRef.afterClosed().subscribe(result => {
              //this.save(action, null);
          });
    
/*        const actionSheet = await this.actionSheetController.create({ 
            header: admin? item.payload.name : item.ad_owner_name+' - '+item.ad_title, 
            buttons: buttons 
        });
        

        await actionSheet.present();
*/
    }

}